import React, {useState} from 'react';
import withHeader from '../../hoc/withHeader';
import {useHistory} from "react-router";
import {storeCategory} from "../../../services/category.service";

const CategoryNewPage = () => {
  const [reqParams, setReqParams] = useState({
    code: '',
    name: '',
  });

  const history = useHistory();

  const handleChange = (event) => {
    const params = {...reqParams}
    params[event.target.name] = event.target.value;
    setReqParams(params);
    // console.log(params)
  }

  const handleBack = () => {
    history.push('/panel/categories');
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      let result = await storeCategory(reqParams);
      console.log(result);
      if (result.status === 201 && result.data.message === 'created') {
        alert('Success Create Category');
        history.push('/panel/categories');
      }
    } catch (e) {
      console.log('error', e.response);
      alert(e.response.data.message);
      return;
    }
    console.log('reqParams', reqParams);
  }

  return (
      <div className="row">
        <div className="col-12">
          <form onSubmit={handleSubmit}>
            <div className="card-body">
              <div className="form-group">
                <label htmlFor="kode">Code</label>
                <input
                    type="text"
                    className="form-control"
                    id="kode"
                    placeholder="Enter code"
                    value={reqParams.code}
                    name='code'
                    onChange={handleChange}
                    required />
              </div>
              <div className="form-group">
                <label htmlFor="name-banks">Name</label>
                <input
                    type="text"
                    className="form-control"
                    id="name-banks"
                    name='name'
                    value={reqParams.name}
                    onChange={handleChange}
                    placeholder="Enter name"
                    required
                />
              </div>
            </div>

            <div className="card-footer">
              <button
                  type="button"
                  className="btn btn-danger float-left"
                  onClick={() => handleBack()}
              >
                Back
              </button>

              <button type="submit" className="btn btn-primary float-right">Submit</button>
            </div>
          </form>
        </div>
      </div>
  );
}

let pageSet = {
  title: "Create Category",
  location: '/panel/categories/new'
}

export default withHeader(pageSet)(CategoryNewPage)
